import React, { FC, ReactNode, useMemo, useState } from 'react';
import UserAccountContext from '../UserAccountContext';

export interface UserAccountProviderProps {
  children: ReactNode;
}

const UserAccountProvider: FC<UserAccountProviderProps> = ({ children }) => {
  const [currentIsProspect, setCurrentIsProspect] = useState(false);
  const [currentIsClient, setCurrentIsClient] = useState(true);

  const saveIsProspect = (value: boolean) => { setCurrentIsProspect(value); };
  const saveIsClient = (value: boolean) => { setCurrentIsClient(value); };

  const context = useMemo(() => (
    {
      isProspect: currentIsProspect,
      isClient: currentIsClient,
      saveIsProspect,
      saveIsClient,
    }), [currentIsProspect, currentIsClient]);

  return (
    <UserAccountContext.Provider value={context}>
      {children}
    </UserAccountContext.Provider>
  );
};

export default UserAccountProvider;
